import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import axios from "axios";
import logo from "../../../assets/logo.png";
import { API_BASE_URL } from "../../../config";

export default function FranchiseListings() {
  

  const [listings, setListings] = useState([]);
  const [filters, setFilters] = useState({
    state: "",
  });

  const options = {
    state: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"],
  };

  // LOAD ALL FRANCHISES
  useEffect(() => {
    async function load() {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/lawn-mowing/franchises/all`);
        setListings(res.data.listings || []);
      } catch (err) {
        console.error("Failed loading franchises:", err);
      }
    }
    load();
 }, [API_BASE_URL]);

  // FILTER
  const filteredListings = listings.filter((l) => {
    const matchState = !filters.state || l.state === filters.state;
    return matchState;
  });

  // STYLES COPIED EXACTLY FROM BUSINESS
  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    overflow: "hidden",
    position: "relative",
    transition: "transform 0.2s ease",
  };

  const viewButton = {
    width: "100%",
    marginTop: "8px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const selectStyle = {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  const buttonStyle = {
    width: "100%",
    padding: "12px",
    backgroundColor: "#2e7d32",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    marginBottom: "10px",
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f4f7f9" }}>
      
      {/* SIDEBAR (IDENTICAL TO BUSINESS) */}
      <aside
        style={{
          width: "250px",
          backgroundColor: "#2e7d32",
          color: "#fff",
          padding: "20px",
          position: "sticky",
          top: 0,
          height: "100vh",
          overflowY: "auto",
          textAlign: "center",
        }}
      >
        <img
          src={logo}
          alt="Client Exchange Logo"
          style={{ width: "140px", margin: "0 auto 25px" }}
        />

        <Link to="/">
          <button style={buttonStyle}>Home</button>
        </Link>

        <h3 style={{ marginTop: "25px", marginBottom: "15px" }}>Filters</h3>

        {/* STATE FILTER */}
        <label style={{ fontWeight: "bold" }}>State:</label>
        <select
          value={filters.state}
          onChange={(e) => setFilters({ state: e.target.value })}
          style={selectStyle}
        >
          <option value="">All</option>
          {options.state.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>

        {/* RESET */}
        <button
          onClick={() => setFilters({ state: "" })}
          style={{
            ...buttonStyle,
            backgroundColor: "#d32f2f",
          }}
        >
          Reset Filters
        </button>
      </aside>

      {/* MAIN CONTENT */}
      <main style={{ flex: 1, padding: "20px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginBottom: "15px",
            color: "#2e7d32",
          }}
        >
          Lawn-Mowing Franchises —{" "}
          <span style={{ color: "#333", fontWeight: "normal" }}>
            {filteredListings.length} Results
          </span>
        </div>

        {filteredListings.length === 0 ? (
          <p style={{ textAlign: "center" }}>No franchises found.</p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "20px",
            }}
          >
            {filteredListings.map((f) => (
              <div
                key={f.id}
                style={cardStyle}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-5px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                {/* IMAGE */}
                <img
                  src="/images/Grass.jpg"
                  alt="franchise"
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />

                {/* CONTENT */}
                <div style={{ padding: "12px 15px" }}>
                  <h2
                    style={{
                      margin: 0,
                      color: "#333",
                      fontSize: "1.2rem",
                      fontWeight: "600",
                    }}
                  >
                    {f.franchise_brand} — {f.territory_name}
                  </h2>

                  <p style={{ margin: "4px 0 10px 0", color: "#777" }}>
                    ID: <strong>FRA-{f.id}</strong>
                  </p>

                  <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
                    Asking Price: ${Number(f.price).toLocaleString()}
                  </div>

                  {/* FRANCHISE SPECIFIC FIELDS */}
                  {f.number_of_clients && (
                    <div style={{ marginTop: "6px", color: "#444" }}>
                      <strong>Clients:</strong> {f.number_of_clients}
                    </div>
                  )}

                  {f.total_client_value && (
                    <div style={{ marginTop: "3px", color: "#444" }}>
                      <strong>Total Client Value:</strong>{" "}
                      ${Number(f.total_client_value).toLocaleString()}
                    </div>
                  )}

                  {/* LOCATION */}
                  <div style={{ color: "#555", marginTop: "5px" }}>
                    <FaMapMarkerAlt color="#d32f2f" /> {f.suburb}, {f.state}
                  </div>

                  <Link to={`/lawn-mowing/franchise/${f.id}`}>
                    <button style={viewButton}>View Franchise</button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
